"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.set-prototype-of");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _warning = _interopRequireDefault(require("warning"));

var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));

var _reactPopover = _interopRequireDefault(require("@nerdwallet/react-popover"));

var _reactLink = _interopRequireDefault(require("@nerdwallet/react-link"));

var _reactTypography = require("@nerdwallet/react-typography");

var _advertiserDisclosureMessage = _interopRequireDefault(require("./advertiser-disclosure-message"));

var _advertiserDisclosureModule = _interopRequireDefault(require("./advertiser-disclosure.module.less"));

var _productTypes = _interopRequireDefault(require("./product-types"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_LABEL = 'Advertiser disclosure';

var deprecationMessage = function deprecationMessage(_ref) {
  var componentName = _ref.componentName,
      version = _ref.version,
      deprecated = _ref.deprecated,
      safe = _ref.safe;
  return "".concat(componentName, " v").concat(version, "+ has deprecated the ").concat(deprecated, " prop. ").concat(safe, " See the CHANGELOG.md for details.");
};

var AdvertiserDisclosure =
/*#__PURE__*/
function (_Component) {
  _inherits(AdvertiserDisclosure, _Component);

  function AdvertiserDisclosure() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AdvertiserDisclosure);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AdvertiserDisclosure)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "warnIfDeprecated", function (currentProps) {
      var componentName = 'AdvertiserDisclosure';
      var deprecatedProps = [{
        version: '5.6',
        deprecated: 'children',
        safe: 'Use the type prop to render the standard, compliance-approved message for your product type.'
      }, {
        version: '5.5',
        deprecated: 'color',
        safe: 'All components will have the same blue color.'
      }, {
        version: '5.5',
        deprecated: 'label',
        safe: "All components will have the same default label, 'Advertiser disclosure.'"
      }];
      deprecatedProps.forEach(function (prop) {
        var deprecated = prop.deprecated,
            safe = prop.safe,
            version = prop.version;
        (0, _warning.default)(currentProps && !currentProps[deprecated], deprecationMessage({
          componentName: componentName,
          version: version,
          deprecated: deprecated,
          safe: safe
        }));
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderDisclosure", function (type) {
      return _react.default.createElement("div", null, _react.default.createElement(_reactTypography.Heading, {
        className: (0, _classes.default)('margin-bottom-3'),
        color: "green",
        level: "3",
        size: 3
      }, "You\u2019re our first priority.", _react.default.createElement("br", null), "Every time."), _react.default.createElement(_advertiserDisclosureMessage.default, {
        type: type
      }));
    });

    return _this;
  }

  _createClass(AdvertiserDisclosure, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.warnIfDeprecated(this.props);
    } // TODO: refactor this to getDerivedStateFromProps with R16 upgrade

  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.warnIfDeprecated(nextProps);
    }
    /**
     * console.error if deprecated props have been used
     * in the component. Handles current props and nextProps
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          color = _this$props.color,
          label = _this$props.label,
          onBackground = _this$props.onBackground;
      return _react.default.createElement(_reactPopover.default, {
        id: "advertiser-disclosure-popover",
        className: (0, _classnames.default)(_defineProperty({}, _advertiserDisclosureModule.default['on-background'], onBackground)),
        popoverClassName: _advertiserDisclosureModule.default.popover,
        popoverContent: _react.default.createElement("div", {
          className: (0, _classes.default)(['text-default', 'max-width-prose-wide'])
        }, children || this.renderDisclosure(this.props.type)),
        shouldDelay: true
      }, _react.default.createElement(_reactLink.default, {
        color: color,
        gotham: true,
        size: 1
      }, label || DEFAULT_LABEL));
    }
  }]);

  return AdvertiserDisclosure;
}(_react.Component);

AdvertiserDisclosure.defaultProps = {
  children: null,
  color: null,
  label: null,
  onBackground: false,
  type: _productTypes.default.CREDIT_CARDS
};
AdvertiserDisclosure.propTypes = {
  /**
   * @deprecated - as of v5.6 allowing custom text or elements to render
   * within the Popover will not be supported. See Changelog for details.
   */
  children: _propTypes.default.node,

  /**
   *  @deprecated - as of v5.5 changing link color will not be possible. See Changelog for details.
   */
  color: _propTypes.default.string,

  /**
   * @deprecated - as of v5.5 changing label will not be supported. See Changelog for details.
   */
  label: _propTypes.default.string,

  /**
   * Flag to indicate if component is not on a white background.
   */
  onBackground: _propTypes.default.bool,

  /**
   * String to indicate which type of advertiser disclosure message to render. Stems from the
   * canoncial marketplace PRODUCT_TYPE fields. Currently
   * supports
   *
   * 0) credit_cards (default)
   * 1) investing
   *
   * More types can be added as needed.
   */
  type: _propTypes.default.oneOf([_productTypes.default.CREDIT_CARDS, _productTypes.default.INVESTING])
};
var _default = AdvertiserDisclosure;
exports.default = _default;
AdvertiserDisclosure.__docgenInfo = {
  "description": "",
  "displayName": "AdvertiserDisclosure",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "@deprecated - as of v5.6 allowing custom text or elements to render\nwithin the Popover will not be supported. See Changelog for details.",
      "defaultValue": {
        "value": "null",
        "computed": false
      }
    },
    "color": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "@deprecated - as of v5.5 changing link color will not be possible. See Changelog for details.",
      "defaultValue": {
        "value": "null",
        "computed": false
      }
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "@deprecated - as of v5.5 changing label will not be supported. See Changelog for details.",
      "defaultValue": {
        "value": "null",
        "computed": false
      }
    },
    "onBackground": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Flag to indicate if component is not on a white background.",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "type": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "PRODUCT_TYPES.CREDIT_CARDS",
          "computed": true
        }, {
          "value": "PRODUCT_TYPES.INVESTING",
          "computed": true
        }]
      },
      "required": false,
      "description": "String to indicate which type of advertiser disclosure message to render. Stems from the\ncanoncial marketplace PRODUCT_TYPE fields. Currently\nsupports\n\n0) credit_cards (default)\n1) investing\n\nMore types can be added as needed.",
      "defaultValue": {
        "value": "PRODUCT_TYPES.CREDIT_CARDS",
        "computed": true
      }
    }
  }
};